module.exports = __webpack_public_path__ + "static/media/mono_filaire_final.8857f848.svg";